import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
// import Snowfall from "react-snowfall";
import reportWebVitals from "./reportWebVitals";
import Loader from "./components/Loader";
import DiscountPopup from "./components/common/DiscountPopup";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function AppWithSnowfall() {
  const [loading, setLoading] = useState(true);
  // const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000); // Adjust the time as needed
    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   if (!loading) {
  //     // Show popup after loading is complete and a short delay
  //     const popupTimer = setTimeout(() => setShowPopup(true), 1000);
  //     return () => clearTimeout(popupTimer);
  //   }
  // }, [loading]);

  if (loading) {
    return <Loader />; // Show the loader while loading
  }

  return (
    <div className="relative">
      <App />
      {/* <Snowfall
        snowflakeCount={300}
        style={{ position: "absolute", inset: 0, pointerEvents: "none" }}
      /> */}
      {/* <DiscountPopup isOpen={showPopup} setIsOpen={setShowPopup} /> */}
    </div>
  );
}

root.render(
  <React.StrictMode>
    <Router>
      <AppWithSnowfall />
    </Router>
  </React.StrictMode>
);

reportWebVitals();
